
    <sbw-button class="unhandled" type="preferred" (click)="unhandled()" text="Unhandled"></sbw-button>
    &nbsp;
    <sbw-button class="throw" type="preferred" (click)="throw()" text="Throw"></sbw-button>